import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Manifesto() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="16032" id="our-story" ref={ref} className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div className={`max-w-3xl mx-auto text-left transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="sr-only">Our Story</h2>
          <div className="font-serif text-xl md:text-2xl leading-relaxed md:leading-[1.7] text-foreground">
            <span className="block font-sans font-bold text-xs md:text-sm tracking-[0.2em] mb-6 text-primary uppercase">
              The Studio
            </span>
            <p>Fanava is a boutique post-production house dedicated to the art of cinematic storytelling. We believe that the final cut is where a film truly finds its soul, requiring a meticulous blend of technical precision and creative intuition. From Edit to finish, our studio operates as a sanctuary for filmmakers who demand excellence and technical mastery in every frame, ensuring that the director's vision is preserved and elevated.&nbsp; &nbsp;<br /><br />Anyone who has worked with hundreds of clients quickly learns what works.</p>
          </div>
        </div>
      </div>
    </section>;
}